import { NextPage } from 'next'
import { asPage, PageProps } from 'src/components/hoc/asPage'
import { ContentSearch } from 'src/compositions/Content/Search'

const ContentSearchPage: NextPage<PageProps<{}>> = () => {
  return <ContentSearch />
}

export default asPage(ContentSearchPage, {
  pageTitle: '経営コラム検索',
  noindex: false,
})
